import {useSearchParams} from 'react-router'

import {PlantViewOption, PlantViewOptions} from '../consts'
import {getUrlParam, setOrDeleteStringParam} from '../utils'

export const usePlantViewState = (
  paramName: string,
  defaultValue: PlantViewOption = PlantViewOptions.REGIONAL_STRUCTURE
) => {
  const [searchParams, setSearchParams] = useSearchParams()

  const plantViewParam = getUrlParam(searchParams, paramName)
  const plantView = isPlantViewOption(plantViewParam) ? plantViewParam : defaultValue

  const setPlantView = (value: PlantViewOption) => {
    const newParams = new URLSearchParams(searchParams)

    setOrDeleteStringParam(newParams, paramName, value)
    setSearchParams(newParams)
  }

  return {plantView, setPlantView}
}

const isPlantViewOption = (value: string | undefined): value is PlantViewOption =>
  Object.values(PlantViewOptions).includes(value as PlantViewOption)
